import { StatusColors } from '@nexelem/components';
import { BatchGanttViewBase, QueueView, TaskGanttView } from '@nexelem/graphne-api';
import { TimeScaleFilterLabel } from './enums';
import { ScaleFilter } from './components/Timeline/TimelineFilterChip';

export enum NodeType {
  EMPTY = 'empty',
  TASK = 'task',
  BREAK = 'break',
  MULTIPLE = 'multiple',
  BATCH = 'batch',
}

export enum NodeQueueEmptyState {
  PAST = 'PAST',
  FUTURE = 'FUTURE',
}

type QueueBasicNode = {
  id?: number | string;
  taskExecutionId?: number;
  startDate: Date;
  endDate: Date;
  nodeWidth: number;
  stretchedEndDate?: Date;
  overlappingNodes?: QueueNode[];
};

export type QueueBreakNode = QueueBasicNode & {
  id: number | string;
  type: NodeType.BREAK;
  queue: QueueView;
};

export type QueueTaskNode = TaskGanttView &
  QueueBasicNode & {
    type: NodeType.TASK;
    isPreviousProductEqual: boolean;
    isNextProductEqual: boolean;
  };

export type QueueBatchNode = BatchGanttViewBase & {
  type: NodeType.BATCH;
  startDate: Date;
  endDate: Date;
  nodeWidth: number;
  overlappingNodes?: QueueNode[];
  stretchedEndDate?: Date;
  isPreviousProductEqual: boolean;
  isNextProductEqual: boolean;
};

export type QueueBatchOrTaskNode = QueueTaskNode | QueueBatchNode;

export type QueueMultipleNode = QueueBasicNode & {
  id: number | string;
  type: NodeType.MULTIPLE;
  tasksAmount: number;
  overlappingNodes: QueueNode[];
  hasBreak: boolean;
};

export type QueueEmptyNode = QueueBasicNode & {
  id: string;
  type: NodeType.EMPTY;
  state: NodeQueueEmptyState;
};

export type QueueNode = QueueTaskNode | QueueBreakNode | QueueBatchNode;

export type GanttQueue<S = QueueNode> = Pick<QueueView, 'shortName' | 'name' | 'area'> & {
  id: number;
  status: StatusColors;
  queueNodes: S[];
};

export type GanttMultipleNodeDrawerProps = {
  readonly queues: GanttQueue<TimelineNode>[];
  readonly nodeIds: Array<string | number>;
  readonly queueId: number;
};

export type TimelineNode = QueueNode | QueueMultipleNode | QueueEmptyNode;

export type DroppableData = {
  readonly queueId: number;
  readonly taskExecutionId?: number;
  readonly predecessorTaskId?: number;
  readonly endDate?: Date;
};

export type TimeScaleFilter = Omit<ScaleFilter, 'label'> & {
  label: TimeScaleFilterLabel;
};
